export default {
    processRepaymentStatus (obj)
    {
        switch (obj)
        {
            case 0:
                return 'krita.repayment.status.new';
            case 1:
                return 'krita.repayment.status.paid';
            case 2:
                return 'krita.repayment.status.cancelled';
            default:
                return 'Opps';
        }
    },
    processBankClaimStatus (obj)
    {
        switch (obj)
        {
            case 0:
                return 'krita.bankclaim.status.unpaid';
            case 1:
                return 'krita.bankclaim.status.paid';
            case 2:
                return 'krita.bankclaim.status.canceled';
            case 3:
                return 'krita.bankclaim.status.secondarycollection';
            case 4:
                return 'krita.bankclaim.status.legalcollection';
            case 5:
                return 'krita.bankclaim.status.returned';
            default:
                return 'Opps';
        }
    },
    processRepaymentType (obj)
    {
        switch (obj) {
            case 1:
                return 'krita.repayment.type.repayment';
            case 2:
                return 'krita.repayment.type.legal';
            default:
                return 'Opps';
        }
    },
    processFactoringStatus(status) {
        switch (status)
        {
            case 0:
                return 'krita.factoring.status.new';
            case 1:
                return 'krita.factoring.status.pending';
            case 2:
                return 'krita.factoring.status.unpaid';
            case 4:
                return 'krita.factoring.status.repaid';
            case 8:
                return 'krita.factoring.status.canceled';
            case 21:
                return 'krita.factoring.status.repaidoutofsystem';
            case 17:
                return 'krita.factoring.status.alterinit';
            case 18:
                return 'krita.factoring.status.altersucceed';
            case 19:
                return 'krita.factoring.status.alterfailed';
            case 20:
                return 'krita.factoring.status.repaidduringprocess';
            default:
                return 'Opps!!';
        }
    },
    processDatabaseAction (obj)
    {
        switch (obj) {
            case 1:
                return 'krita.action.insert';
            case 2:
                return 'krita.action.update';
            case 3:
                return 'krita.action.delete';
            default:
                return 'Oops'
        }
    },
    processTransferTrigger (obj)
    {
        switch (obj) {
            case 0:
                return 'krita.factoring.transferstatus.applicationcompletion';
            case 1:
                return 'krita.factoring.transferstatus.factoringbufferreturn';
            case 2:
                return 'krita.factoring.transferstatus.overpayment';
            case 3:
                return 'krita.factoring.transferstatus.nonstandart';
            default:
                return 'Oops'
        }
    },
    processPaymentSource (obj)
    {
        switch (obj) {
            case 0:
                return 'krita.factoring.paymentsource.manual';
            case 1:
                return 'krita.factoring.paymentsource.querybank';
            case 2:
                return 'krita.factoring.paymentsource.refactoring';
            case 3:
                return 'krita.factoring.paymentsource.settling';
            case 4:
                return 'krita.factoring.paymentsource.feerepayment';
            case 5:
                return 'krita.factoring.paymentsource.inkassomanual';
            case 6:
                return 'krita.factoring.paymentsource.repayment';
            default:
                return 'Oops'
        }
    },

    processApplicationStatus(status) {
        switch (status)
        {
            case 0:
                return 'krita.application.status.new';
            case 1:
                return 'krita.application.status.pending';
            case 2:
                return 'krita.application.status.processing';
            case 4:
                return 'krita.application.status.completed';
            case 8:
                return 'krita.application.status.canceled';
            default:
                return 'Opps';
        }
    },
    processTransferType (transferType)
    {
        switch (transferType) {
            case 4:
                return 'krita.transfers.applications';
            case 3:
                return 'krita.transfers.bankClaims';
            case 2:
                return 'krita.transfers.factorings';
            case 1:
                return 'krita.transfers.repayments';
            default:
                return 'Opps';
        }
    },
}